import { render } from "./GigaUpload.vue?vue&type=template&id=0b14c8c6&scoped=true"
import script from "./GigaUpload.vue?vue&type=script&lang=js"
export * from "./GigaUpload.vue?vue&type=script&lang=js"

import "./GigaUpload.vue?vue&type=style&index=0&id=0b14c8c6&lang=scss&scoped=true"
import "./GigaUpload.vue?vue&type=style&index=1&id=0b14c8c6&lang=css"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b14c8c6"]])

export default __exports__